import { __assign } from "tslib";
import { SolutionGrid, SolutionGridFull, } from '@wix/app-market-collection-widget';
import * as React from 'react';
import { config } from '../../config';
import { Path } from '../..';
import { getBundleAppSavedPrice, isBundleAppAndInstalled, isBundleAppAndNotInstalled, isBundleAppWithVoucher, openOrAddApp, shouldRenderAsLink, sortSolutionsByInstalled, } from '../../common/utils';
import { addUrl } from '../../common/addUrl';
import { composer } from '../../component-decorators/composer';
import { useConfigContext } from '../../config-context';
import { getReferralInfo, getRouteForBi, getTagName, } from '../../common/bi-events';
import { isAppSetupIncomplete } from '../../common/is-app-setup-incomplete';
var getSolutionsBiData = function (solutions, marketplaceStore) {
    if (solutions) {
        var metaSiteId_1 = marketplaceStore.metaSiteId, route = marketplaceStore.route, prevRoute = marketplaceStore.prevRoute, bundleApps_1 = marketplaceStore.bundleApps;
        var _a = getRouteForBi(route, prevRoute), market_1 = _a.market, tagName_1 = _a.tagName, tagType_1 = _a.tagType, subCategory_1 = _a.subCategory, referralInfo_1 = _a.referralInfo, section_1 = _a.section, searchTerm_1 = _a.searchTerm, widgetReferral_1 = _a.widgetReferral;
        return solutions.map(function (solution, index) {
            return {
                msid: metaSiteId_1,
                appId: solution.id,
                impressionType: 'box',
                index: index,
                market: market_1,
                tagName: tagName_1.replace(/-/g, '_'),
                tagType: tagType_1,
                subCategory: subCategory_1,
                section: section_1,
                referralInfo: referralInfo_1,
                searchTerm: searchTerm_1,
                widgetReferral: widgetReferral_1,
                isBundleAppNotInstalled: isBundleAppAndNotInstalled(solution.id, bundleApps_1),
                isBundleAppInstalled: isBundleAppAndInstalled(solution.id, bundleApps_1),
            };
        });
    }
    return [];
};
function enricheSolutions(baseUrl, solutions, marketplaceStore, experiments) {
    if (!solutions) {
        return [];
    }
    var installedApps = marketplaceStore.installedApps, siteIsPremium = marketplaceStore.siteIsPremium, bundleApps = marketplaceStore.bundleApps;
    return addUrl(baseUrl, solutions.map(function (solution, appIndex) {
        var _a;
        return __assign(__assign({}, solution), { appIndex: appIndex, isInstalled: installedApps &&
                installedApps.some(function (installedApp) { return installedApp.webSolutionBase.id === (solution === null || solution === void 0 ? void 0 : solution.id); }), showPremiumLabel: !siteIsPremium && ((_a = solution === null || solution === void 0 ? void 0 : solution.pricing) === null || _a === void 0 ? void 0 : _a.isRequiredWixPremium), isBundleAppNotInstalled: isBundleAppAndNotInstalled(solution === null || solution === void 0 ? void 0 : solution.id, bundleApps), isBundleAppInstalled: isBundleAppAndInstalled(solution === null || solution === void 0 ? void 0 : solution.id, bundleApps), savedPrice: getBundleAppSavedPrice(solution === null || solution === void 0 ? void 0 : solution.id, bundleApps), isVoucherApp: isBundleAppWithVoucher(solution === null || solution === void 0 ? void 0 : solution.id, bundleApps), isAppSetupIncomplete: isAppSetupIncomplete(installedApps === null || installedApps === void 0 ? void 0 : installedApps.find(function (installedApp) {
                return installedApp.webSolutionBase.id === (solution === null || solution === void 0 ? void 0 : solution.id);
            }), experiments) });
    }));
}
var getWixRecordingAttribute = function (experiments) {
    return function (solution) {
        if (!(experiments && experiments.enabled('specs.marketplace.includeFullstory'))) {
            // @ts-ignore
            window &&
                // @ts-ignore
                window.wixRecorder &&
                // @ts-ignore
                window.wixRecorder.addCustomAttribute('clickOnAppBox', solution.name);
        }
    };
};
export var SolutionGridWrapper = composer()
    .withMarketplaceStore()
    .withExperiments()
    .compose(function (_a) {
    var marketplaceStore = _a.marketplaceStore, solutions = _a.solutions, solutionsBiData = _a.solutionsBiData, colSpan = _a.colSpan, experiments = _a.experiments, isFull = _a.isFull, collimp_id = _a.collimp_id, referralSectionName = _a.referralSectionName, sortSolutions = _a.sortSolutions, layout = _a.layout, hideTagsBadge = _a.hideTagsBadge, section = _a.section, numberOfLines = _a.numberOfLines;
    var onButtonClick = function (solution) {
        openOrAddApp(solution, marketplaceStore, biData[solution.appIndex], configContext, experiments, false, referral, referralTag);
    };
    var onBoxClick = function (solution) {
        config.goto({
            path: Path.WEB_SOLUTION,
            slug: solution.slug,
            referral: referral,
            appIndex: solution.appIndex,
            referralTag: referralTag,
            collimp_id: collimp_id,
            referralSectionName: referralSectionName,
            section: section,
        });
        wixRecordingAttribute(solution);
    };
    var biData = solutionsBiData
        ? solutionsBiData
        : getSolutionsBiData(solutions, marketplaceStore);
    for (var i in biData) {
        biData[i].referralSectionName = referralSectionName;
    }
    // tslint:disable-next-line:react-hooks-nesting
    var configContext = useConfigContext();
    var locale = configContext.locale, i18n = configContext.i18n, baseUrl = configContext.baseUrl, isMobile = configContext.isMobile;
    var referral = getReferralInfo(null, marketplaceStore.route);
    var referralTag = getTagName(marketplaceStore.route);
    var wixRecordingAttribute = getWixRecordingAttribute(experiments);
    var enrichedSolutions = enricheSolutions(baseUrl, solutions, marketplaceStore, experiments);
    if (sortSolutions) {
        enrichedSolutions = sortSolutionsByInstalled(enrichedSolutions);
    }
    var solutionGridProps = {
        i18n: i18n,
        locale: locale,
        as: shouldRenderAsLink(),
        solutions: enrichedSolutions,
        solutionsBiData: __assign({}, biData),
        isCompany: !(experiments === null || experiments === void 0 ? void 0 : experiments.enabled('specs.marketplace.hideDevName')),
        onButtonClick: onButtonClick,
        onBoxClick: onBoxClick,
        colSpan: colSpan,
        experiments: experiments,
        hideCTA: true,
        isMobile: isMobile,
        layout: layout,
        hideTagsBadge: hideTagsBadge,
        numberOfLines: numberOfLines,
    };
    return (React.createElement("div", { "data-testid": "solution-grid-wrapper" }, isFull ? (React.createElement(SolutionGridFull, __assign({}, solutionGridProps))) : (React.createElement(SolutionGrid, __assign({}, solutionGridProps)))));
});
//# sourceMappingURL=solution-grid-wrapper.js.map